import { Component, OnInit } from '@angular/core';
import { Utility } from '../../_service/utility';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-dn-copyright',
  templateUrl: './dn-copyright.component.html',
  styleUrls: ['./dn-copyright.component.scss']
})
export class DnCopyrightComponent implements OnInit {
  isApp = environment.app;
  constructor(
    private _utility:Utility

  ) { }
  copyRight = this._utility.getSiteConfig.copyRight;
  host = this._utility.GetHost();
  ngOnInit() {
  }

}
